<section id="slider-header">
  <a href="/"><img src="./assets/img/common/logo-white.png" alt="company-logo" class="iw-header-logo"></a>
  <h2>{{ header_title }}</h2>
</section>